import { render, staticRenderFns } from "./Position.vue?vue&type=template&id=3502d354&scoped=true&lang=pug&"
import script from "./Position.vue?vue&type=script&lang=ts&"
export * from "./Position.vue?vue&type=script&lang=ts&"
import style0 from "./Position.vue?vue&type=style&index=0&id=3502d354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3502d354",
  null
  
)

export default component.exports